import { render, staticRenderFns } from "./OnboardingIntegrationSettings.vue?vue&type=template&id=e773bbea&scoped=true&lang=pug"
import script from "./OnboardingIntegrationSettings.vue?vue&type=script&lang=ts"
export * from "./OnboardingIntegrationSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e773bbea",
  null
  
)

export default component.exports